import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Yo terminaba resolviendo todo sobre la marcha. Lo que más me ayudó fue empezar a tener estructura para situaciones repetidas.',
  name: 'Camila R.',
  role: 'Peluquera independiente — Buenos Aires'
}, {
  quote: 'El problema nunca fue la técnica. Era el caos operativo. Este tipo de sistema te ordena muchísimo.',
  name: 'Sofía M.',
  role: 'Estilista — Córdoba'
}, {
  quote: 'Mis clientas empezaron a notar más claridad y seguridad incluso en cómo respondía consultas.',
  name: 'Luciana G.',
  role: 'Home Studio — Rosario'
}];
export function Testimonials() {
  return <section className="bg-[#0B0B12] py-16 px-5 relative overflow-hidden" data-id="element-329">
      <div className="blur-circle bg-brand-gold/5 -top-20 -right-20 opacity-20" data-id="element-330" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-331">
        <h2 className="md:text-3xl font-black text-center text-white mb-12 text-[20px] uppercase tracking-tight" data-id="element-332">
          💬 ¿Qué dicen profesionales que ya trabajan buscando más estructura?
        </h2>

        <div className="space-y-6" data-id="element-333">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-2xl transition-all hover:bg-white/10 hover:border-brand-gold/30 shadow-2xl" data-id="element-334">
              <div className="flex gap-1 mb-4" data-id="element-335">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} className="fill-brand-gold text-brand-gold" data-id="element-336" />)}
              </div>
              <p className="text-slate-300 italic text-base mb-6 leading-relaxed font-medium" data-id="element-337">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-338">
                <div className="w-10 h-10 rounded-full bg-brand-gold/10 border border-brand-gold/20 flex items-center justify-center text-brand-gold font-black" data-id="element-339">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-340">
                  <p className="font-black text-white text-sm uppercase tracking-tight" data-id="element-341">
                    {t.name}
                  </p>
                  <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.2em]" data-id="element-342">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}